import React, { useEffect, useState } from "react";
import { Ghost } from "lucide-react";

export const PhantomPanel = ({ critique, onDismiss, visible }) => {
    const [typed, setTyped] = useState("");

    useEffect(() => {
        if (!critique?.line) { setTyped(""); return; }
        let i = 0;
        const full = critique.line;
        setTyped("");
        const interval = setInterval(() => {
            i++;
            setTyped(full.slice(0, i));
            if (i >= full.length) clearInterval(interval);
        }, 22);
        return () => clearInterval(interval);
    }, [critique]);

    if (!visible || !critique) return null;

    return (
        <div
            className="relative border border-magenta bg-black p-5 scanlines overflow-hidden"
            role="dialog"
            aria-live="assertive"
            aria-label="Phantom critique"
            data-testid="phantom-modal"
        >
            <div className="flex items-center gap-2 mb-3">
                <Ghost size={18} className="text-magenta glitch" />
                <span className="text-magenta text-[10px] tracking-[0.3em] uppercase font-crt text-shadow-magenta">
                    Transmission · The Phantom
                </span>
            </div>
            <div className="text-[var(--text-secondary)] italic text-xs mb-3 font-mono">
                {critique.intro}
            </div>
            <div
                className="text-amber font-crt text-2xl leading-snug caret"
                data-testid="phantom-line"
            >
                {typed}
            </div>
            <button
                onClick={onDismiss}
                className="mt-5 dial-btn px-4 py-2 text-xs"
                data-testid="phantom-dismiss"
                aria-label="Acknowledge Phantom critique"
            >
                ▶ Acknowledge
            </button>
        </div>
    );
};

export default PhantomPanel;
